import React, { useRef, useState } from "react";
import Input from "../../common/InputField";
import {
  Box,
  Button,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Divider,
} from "@mui/material";


function PlanAndBillingCompany() {

  const [selectedPlan, setSelectedPlan] = useState("Business plan");



  const plans = [{ name: "Basic plan", desc: "Includes up to 10 users, 20GB individual data and access to all features." }, { name: "Business plan", desc: "Includes up to 10 users, 20GB individual data and access to all features." }, { name: "Enterprise plan", desc: "Includes up to 10 users, 20GB individual data and access to all features." },];
  // Options
  const orderHistory = [
    { date: "January 6, 2023", type: "Pro Business Annual", receipt: "Html | PDF" },
    { date: "January 6, 2023", type: "Pro Business Annual", receipt: "Html | PDF" },
    { date: "January 6, 2023", type: "Pro Business Annual", receipt: "Html | PDF" },
    { date: "January 6, 2023", type: "Pro Business Annual", receipt: "Html | PDF" },
  ];


  return (
    <>
      <div className="profile-main-container">
        <Box sx={{ paddingTop: "24px !important" }} className="Notification-Main-Container">
          <Box>
            <Box className="Personal-Info-Text-Container">
              <Typography sx={{ marginTop: '7px !important', paddingBottom: '8px !important' }} className="Personal-Info-Text">Plan & Billing</Typography>
              <Typography
                className="notification-description"
                whiteSpace="pre-line"
              >
                Stay updated with your subscription details,{'\n'}payments, and billing information
              </Typography>
            </Box>
          </Box>

          <Box width="552px">
            <Box>
              <Box className="subscripe-main-container">
                <Typography sx={{ paddingBottom: '7px !important' }} className="Personal-Info-Text">Pro Business Monthly: Expired</Typography>
                <Typography className="notification-description" color="#556575">
                  Expired August 18, 2022
                </Typography>

                <Box className="plan-btn-main-container">
                  <Button className="plan-btn">Cancel subscription</Button>
                  <Button className="plan-btn">Downgrade to Annual</Button>
                  <Button className="plan-btn">Switch to monthly</Button>
                </Box>
              </Box>

              <RadioGroup
                value={selectedPlan}
                onChange={(e) => setSelectedPlan(e.target.value)}
                sx={{ display: "grid", gap: '8px', mb: 3, mt: "8px" }}
              >
                {plans.map((plan) => {
                  const isSelected = selectedPlan === plan.name;
                  return (
                    <Paper
                      key={plan.name}
                      elevation={0}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1.5,
                        pl: "23px",
                        pt: '21px',
                        pb: '18px',
                        height: '80px',
                        overflow: "hidden",
                        border: 1,
                        borderColor: isSelected ? "#148DFD" : "#E5E9EC",
                        bgcolor: isSelected ? "#F3FBFF" : "#FFFFFF",
                        borderRadius: "8px",
                        cursor: "pointer",
                        ...(isSelected
                          ? {}
                          : {
                            "&:hover": {
                              borderColor: "#C5CED6",
                            },
                          }),

                      }}
                      onClick={() => setSelectedPlan(plan.name)}
                    >
                      <FormControlLabel
                        value={plan.name}
                        control={
                          <Radio
                            disableRipple
                            sx={{
                              p: 0,
                              mt: "2px",
                              "& .MuiSvgIcon-root": { fontSize: 18 },
                            }}
                          />
                        }
                        label={
                          <Box>
                            <Typography
                              sx={{
                                color: "#061522",
                                fontFamily: "Inter, sans-serif",
                                fontSize: "14px",
                                fontWeight: 500,
                                lineHeight: "20px",
                              }}
                            >
                              {plan.name}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#556575",
                                fontFamily: "Inter, sans-serif",
                                fontSize: "14px",
                                lineHeight: "20px",
                              }}
                            >
                              {plan.desc}
                            </Typography>
                          </Box>
                        }
                        sx={{
                          flex: 1,
                          alignItems: "flex-start",
                          m: 0,
                          gap: "8px",
                          "& .MuiFormControlLabel-label": {
                            display: "block",
                            whiteSpace: "normal",
                            overflow: "visible",
                          },
                        }}
                      />
                    </Paper>
                  );
                })}
              </RadioGroup>

              {/* Order History */}
              <Box>
                <Typography
                  className="Personal-Info-Text"
                  sx={{ fontSize: "14px !important", mb: "25px !important", pb: '0 !important' }}
                >
                  Order History
                </Typography>

                <Table size="small" aria-label="order-history">
                  <TableHead>
                    <TableRow
                      sx={{
                        "& th": {
                          color: "#405261",
                          fontFamily: "Inter",
                          fontSize: "12px",
                          fontWeight: 400,
                          pb: '9px',
                          pl: 0,
                        },
                      }}
                    >
                      <TableCell>Date</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Receipt</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {orderHistory.map((order, idx) => (
                      <TableRow
                        key={idx}
                        sx={{
                          "&:hover": { backgroundColor: "#F9FAFA" },
                          "&:hover td": { backgroundColor: "#F9FAFA" },
                          "& td": {
                            color: "#405261",
                            fontFamily: "Inter",
                            fontSize: "14px",
                            fontWeight: 400,
                            height: "64px",
                            pl: 0,
                          },
                        }}
                      >
                        <TableCell>{order.date}</TableCell>
                        <TableCell>{order.type}</TableCell>
                        <TableCell>{order.receipt}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>

                <Box textAlign="center" mt={2}>
                  <Button
                    size="small"
                    sx={{
                      color: "#148DFD",
                      fontSize: "14px",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      textDecoration: "underline",
                      textUnderlineOffset: "4px",
                      textTransform: "none",
                    }}
                    onClick={() => console.log("View more")}
                  >
                    View More
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    </>
  );
}

export default PlanAndBillingCompany;